import { Component, OnDestroy, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { HttpParams } from '@angular/common/http';
import { Params, Router } from '@angular/router';
import { ProvidersService } from '../../providers.service';

@Component({
  selector: 'app-consumer-pricelist',
  templateUrl: './consumer-pricelist.component.html',
  styleUrls: ['./consumer-pricelist.component.scss'],
})
export class ConsumerPricelistComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  columnDefs
  rowData: any = [];
  rowSelection: string;
  private gridApi;
  private gridColumnApi;
  showEditRetailer: boolean = false;
  selectedRows: any;
  searchValue: any;
  Pricelists: Array<any>;
  PricelistSelected;
  isPricelistSelected: boolean = false;


  constructor(private router: Router, private providersService: ProvidersService) {
    super();
    let httpParams: Params = { input: 'null' }
    //let pricelisttype : 'ho'
    this.providersService.getAllActivePricelists().subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        //;
        this.Pricelists = resData;
      }
    })
  }

  ngOnInit(): void {
    super.ngOnInit()


    this.rowSelection = 'single';
    this.columnDefs = [

      { field: 'null', headerName: 'Action', width: 110, checkboxSelection: true },
      { field: 'sku', headerName: 'SKU', width: 80 },
      { field: 'productName', headerName: 'Product name' },
      { field: 'productDescription', headerName: 'Product description' },
      { field: 'productType', headerName: 'Product type', width: 110 },
      { field: 'productStatus', headerName: 'Status', },
      { field: 'carrier', headerName: 'Carrier', width: 100 },
      { field: 'providerService', headerName: 'Provider Service' },
      { field: 'country', headerName: 'Service country' },
      { field: 'currency', headerName: 'Top-up Currency' },
      { field: 'faceValueMaxAmt', headerName: 'Face value max' },
      { field: 'discount', headerName: 'Purchase Discount' },
      { field: 'plan1_commission', headerName: 'Plan1 commission for Sales distributor/reps' },
      { field: 'plan2_commission', headerName: 'Plan2 commission for Sales distributor/reps' },
      { field: 'commission_Value', headerName: 'Commission value', },
      { field: 'commission_Value_type', headerName: 'Commission value type', },
      { field: 'Exchange Rate', headerName: 'Exchange Rate', },
      { field: 'faceValueMaxAmt', headerName: 'Face value max', },
      { field: 'faceValueMinAmt', headerName: 'Face value min', },
      { field: 'Invoice Grouping', headerName: 'Invoice Grouping', },
      { field: 'planType', headerName: 'Plan Type', },
      { field: 'providerId', headerName: 'Provider Id', },
      { field: 'providerName', headerName: 'Provider Name', },
      { field: 'purchase_price', headerName: 'Purchase price', },
      { field: 'purchase_price_type', headerName: 'purchase price type', },
      { field: 'responseType', headerName: 'Response Type', },
      { field: 'transactiontype', headerName: 'Transaction type', },

    ]
  }


  onSelectionChanged(e) {
    this.router.navigate
   
    this.selectedRows = this.gridApi.getSelectedRows();
    if (this.selectedRows && this.selectedRows != []) {
      this.showEditRetailer = true;
    }

  }


  onPricelistSelect(e) {
    this.providersService.getAllproductsforPricelist(this.PricelistSelected).subscribe(
      res => {
        this.rowData = res.data;
        this.isPricelistSelected = true;
      }
    );
  }



  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  exportData() {
    this.gridApi.exportDataAsCsv();
  }

  editPricelist() {
    let _productId = this.selectedRows[0].productId;
    //let _productId = 35;
    this.router.navigate([`features/providers/pricelists/update-product/${_productId}`])
    //this.router.navigate(['features/providers/pricelists/update-product/35'])
  }
  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }

}


